import React, { useState } from 'react';
import { TextField } from '@mui/material';

const InstanceFormFields = ({ instanceData, setInstanceData }) => {
    const [errors, setErrors] = useState({});

    if (!instanceData) return null;

    // Validation helpers
    const handleMobileChange = (value) => {
        // Allow only numbers
        const cleaned = value.replace(/\D/g, '');
        setInstanceData({ ...instanceData, mobile: cleaned });

        // Optional: set error if not 10 digits
        setErrors((prev) => ({
            ...prev,
            mobile: cleaned.length < 10 ? 'Mobile number should be 10 digits' : ''
        }));
    };

    const handleEmailChange = (value) => {
        setInstanceData({ ...instanceData, email: value });
        // Simple email regex validation
        const emailRegex = /^\S+@\S+\.\S+$/;
        setErrors((prev) => ({
            ...prev,
            email: value && !emailRegex.test(value) ? 'Invalid email address' : ''
        }));
    };

    const handleGstChange = (value) => {
        setInstanceData({ ...instanceData, gst: value.toUpperCase() });
        // Optional GST regex (India GST format)
        const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
        setErrors((prev) => ({
            ...prev,
            gst: value && !gstRegex.test(value) ? 'Invalid GST number' : ''
        }));
    };

    return (
        <>
            {/* Branding Logo */}
            <TextField
                fullWidth
                label="Branding Logo URL"
                margin="dense"
                value={instanceData.logo || ''}
                onChange={(e) => setInstanceData({ ...instanceData, logo: e.target.value })}
            />

            {/* Brand Name */}
            <TextField
                fullWidth
                label="Brand Name"
                margin="dense"
                value={instanceData.name || ''}
                onChange={(e) => setInstanceData({ ...instanceData, name: e.target.value })}
            />

            {/* Address 1 */}
            <TextField
                fullWidth
                label="Address Line 1"
                margin="dense"
                value={instanceData.address1 || ''}
                onChange={(e) => setInstanceData({ ...instanceData, address1: e.target.value })}
            />

            {/* Address 2 */}
            <TextField
                fullWidth
                label="Address Line 2"
                margin="dense"
                value={instanceData.address2 || ''}
                onChange={(e) => setInstanceData({ ...instanceData, address2: e.target.value })}
            />

            {/* Mobile */}
            <TextField
                fullWidth
                label="Mobile Number"
                margin="dense"
                type="tel"
                value={instanceData.mobile || ''}
                onChange={(e) => handleMobileChange(e.target.value)}
                error={!!errors.mobile}
                helperText={errors.mobile}
            />

            {/* Email */}
            <TextField
                fullWidth
                label="Email"
                margin="dense"
                type="email"
                value={instanceData.email || ''}
                onChange={(e) => handleEmailChange(e.target.value)}
                error={!!errors.email}
                helperText={errors.email}
            />

            {/* GST */}
            <TextField
                fullWidth
                label="GST Number"
                margin="dense"
                value={instanceData.gst || ''}
                onChange={(e) => handleGstChange(e.target.value)}
                error={!!errors.gst}
                helperText={errors.gst}
            />

            {/* Website */}
            <TextField
                fullWidth
                label="Website Link"
                margin="dense"
                value={instanceData.website || ''}
                onChange={(e) => setInstanceData({ ...instanceData, website: e.target.value })}
            />
        </>
    );
};

export default InstanceFormFields;
